<div class="container">
  <app-logo></app-logo>

  @if (ssoStep() === "twoFactor") {
    <form [formGroup]="twoFactorForm" (keydown.enter)="submitTwoFactor()">
      <div class="form-content">
        <h1>{{ "LOGIN_PAGE.TITLE" | translate }}</h1>
        @if (ssoEmail(); as email) {
          <p class="sso-identity">
            {{ "LOGIN_PAGE.SIGNED_IN_WITH_GOOGLE_AS" | translate }}
            <strong>{{ email }}</strong>
          </p>
        }
        <mat-form-field appearance="outline" color="primary">
          <mat-label>{{ "LOGIN_PAGE.AUTHENTICATOR_CODE" | translate }}</mat-label>
          <input
            matInput
            [appInputMask]="twoFaMask"
            type="text"
            placeholder="{{ 'LOGIN_PAGE.ENTER_CODE_FROM_AUTHENTICATOR' | translate }}"
            formControlName="twoFACode"
            autofocus
          />
        </mat-form-field>
        @if (errorMessage(); as error) {
          <app-alert (clear)="clearError()" [closable]="true">
            {{ error | translate }}
          </app-alert>
        }
        <button
          (click)="submitTwoFactor()"
          mat-raised-button
          color="primary"
          type="button"
          [disabled]="ssoPending()"
        >
          {{ "LOGIN_PAGE.CONFIRM" | translate }}
        </button>
        <button (click)="useAnotherAccount()" mat-button type="button" class="sso-cancel">
          {{ "LOGIN_PAGE.USE_A_DIFFERENT_ACCOUNT" | translate }}
        </button>
      </div>
    </form>
  } @else {
    <form [formGroup]="form" (keydown.enter)="login()">
      <div class="form-content">
        <h1>{{ "LOGIN_PAGE.TITLE" | translate }}</h1>
        <mat-form-field appearance="outline">
          <mat-label>{{ "LOGIN_PAGE.EMAIL" | translate }}</mat-label>
          <input
            matInput
            type="text"
            placeholder="john.doe@email.com"
            formControlName="login"
            autofocus
          />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ "LOGIN_PAGE.PASSWORD" | translate }}</mat-label>
          <input
            matInput
            type="password"
            placeholder="password"
            formControlName="password"
          />
        </mat-form-field>
        <mat-form-field appearance="outline" color="primary">
          <mat-label>{{ "LOGIN_PAGE.AUTHENTICATOR_CODE" | translate }}</mat-label>
          <input
            matInput
            [appInputMask]="twoFaMask"
            type="text"
            placeholder="{{ 'LOGIN_PAGE.ENTER_CODE_FROM_AUTHENTICATOR' | translate }}"
            formControlName="twoFACode"
          />
          <mat-hint>{{ "LOGIN_PAGE.TWO_FA_HINT" | translate }}</mat-hint>
        </mat-form-field>
        @if (errorMessage(); as error) {
          <app-alert (clear)="clearError()" [closable]="true">
            {{ error | translate }}
          </app-alert>
        }
        <button (click)="login()" mat-raised-button color="primary" type="button">
          {{ "LOGIN_PAGE.LOG_IN" | translate }}
        </button>
        @if (googleSsoEnabled && googleReady()) {
          <div class="sso-divider">
            <span>{{ "LOGIN_PAGE.OR" | translate }}</span>
          </div>
          <div #googleButton class="google-button-host"></div>
        }
      </div>
    </form>
  }
</div>
